export default __webpack_public_path__ + "static/media/mthui.ed6dac62.png";